import { Pages } from '.generated/Project.CW.model';
import type { WithContext, Service, MedicalWebPage } from 'schema-dts';
import { stripHtmlTags } from 'lib/utils/string-utils';

export const buildMedicalWebPageJsonLd = (
  data: Pages.Specialty,
  pageUrl: string
): WithContext<MedicalWebPage> => ({
  '@context': 'https://schema.org',
  '@type': 'MedicalWebPage',
  name: data.fields?.Title?.value,
  description: stripHtmlTags(data.fields?.Description?.value),
  url: pageUrl,
});

export const buildServiceJsonLd = (
  data: Pages.Specialty,
  pageUrl: string
): WithContext<Service> => ({
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: data.fields?.Title?.value,
  description: stripHtmlTags(data.fields?.Description?.value ?? ''),
  url: pageUrl,
  provider: {
    '@type': 'Organization',
    name: "Children's Wisconsin",
    url: 'https://childrenswi.org/',
  },
});
